export default "__VITE_ASSET__DXAZyDIl__"